<template>
  <div class="control">
    <div class="field has-addons">
      <div class="control is-expanded">
        <input class="input" type="text" disabled :value="readonlyValue" />
      </div>
      <p class="control">
        <button class="button is-info" @click="copyToClipboard">
          <span class="icon">
            <font-awesome-icon icon="copy"></font-awesome-icon>
          </span>
        </button>
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Toast from '@/shared/services/toast';
import { useClipboard } from '@vueuse/core';

const props = defineProps({
  readonlyValue: {
    type: String,
    required: true,
  },
  onCopyMessage: {
    type: String,
    required: true,
  },
});

const { copy, isSupported } = useClipboard();

function copyToClipboard() {
  if (isSupported.value) {
    copy(props.readonlyValue);
    Toast.showInfo(props.onCopyMessage);
  } else {
    Toast.showError('Clipboard not supported');
  }
}
</script>
